<template lang="pug">
    #modal-cancelamento-assincronos
        el-dialog(
            width='720px',
            :visible='abrirModalCancelar',
            :show-close='false',
            :close-on-click-modal='false'
        )
            .template(slot='title')
                .box-header
                    .box-header--icon
                        i.mdi.mdi-alert-circle.warning
                    .box-header--title Cancelar as transferências
            .col
                .row.texto
                    | Ao cancelar, as transferências que estão com status
                    .negrito &nbsp;Na Fila&nbsp;
                    | não terão continuidade.
                .row.texto-2
                    | Tem certeza que deseja cancelar?
            footer(slot='footer')
                BaseButton.cancelar-transferencias(type='default', @click='limparFilaEspera') Cancelar transferências
                BaseButton.continuar-transferencias(type='primary', @click='fecharModal') Continuar transferências
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalCancelamentoAssincronos',
    components: {
        BaseButton
    },
    emits: ['limpar-fila-espera', 'fechar-modal-cancelar'],
    props: {
        abrirModalCancelar: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {
        fecharModal() {
            this.$emit('fechar-modal-cancelar');
        },
        limparFilaEspera() {
            this.$emit('limpar-fila-espera');
        }
    }
};
</script>

<style lang="scss">
#modal-cancelamento-assincronos {
    .el-dialog__header {
        padding: 0;
    }

    .box-header {
        height: 54px;
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: #E9E9E9;

        .box-header--icon {
            margin-right: 10px;
        }

        .box-header--title {
            font-size: 16px;
            font-weight: 500;
            color: #3B3B3B;
        }

        .mdi:before,
        .mdi-set {
            font-size: 19px;
            color: #DDAC44;
        }
    }

    .el-dialog__body {
        margin: 0;
        padding: 0 !important;
        height: 88px;
    }

    .negrito {
        font-size: 14px;
        font-weight: 500;
        color: #3B3B3B;
    }

    .texto {
        padding: 16px 16px 8px 16px;
        font-size: 14px;
        color: #3B3B3B;
    }

    .texto-2 {
        padding: 8px 16px 16px 16px;
        font-size: 14px;
        font-weight: 500;
        color: #3B3B3B;
    }

    .el-dialog__footer {
        height: 56px;
        padding: 8px 16px;
    }

    footer {
        display: flex;
        justify-content: flex-end;
    }

    .cancelar-transferencias {
        color: var(--primary);
    }

    .continuar-transferencias {
        margin-left: 24px;
    }
}
</style>
